'use strict';
import * as _ from 'lodash';
import { module } from '../app';
import * as commonConstants from '../constants/constantStrings';

module
  .factory('ContactDocumentCreateDialogModel', [
    'documentsSvc', 'modalService', '$ionicLoading', 'signalrService', 'datePickerService', 'FollowUpsDomain',
    function (documentsSvc, modalService, $ionicLoading, signalrService, datePickerService, FollowUpsDomain) {

      function ContactDocumentCreateDialogModel(patientAccessToken, contactId, clip, ssn, checkIfStillOwningAndNotOffline) {
        let self = this;

        self.loading = false;
        self.modalInstance = null;
        self.showValidationResults = false;
        self.highlightFuInvalidData = false;
        self.followUpsOnDue = [];
        self.recommendations = [];
        self.resolutions = [];
        self.patientAccessToken = patientAccessToken;
        self.contactId = contactId;
        self.clip = clip;
        self.ssn = ssn;
        self.contact = {
          Code : '',
          Comment: '',
          ContactDate: undefined
        };
        self.contactCopy = undefined;
        self.highlightInvalidData = false;
        self.areFollowUpsLoaded = false;
        self.followUpOnDueToResolve = undefined;
        self.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;

        self.init = async (modal, scope) => {
          $ionicLoading.show({
            template: commonConstants.DEFAULT_LOADER_MESSAGE
          });
          self.modalInstance = modal;
          self._scope = scope;

          await self.loadContactTypes();

          if(self.contactId){
            await self.loadContact();
          }

          self.processDataOnInit();

          await self.loadFollowUpsOnDue();

          $ionicLoading.hide();
        };

        self.processDataOnInit = () => {
          self.titleText = `${self.contactId ? 'Edit' : 'Add'} Contact`;
          let contactDate = new Date();
          if(self.contact.ContactDate &&
             self.contact.ContactDate !== commonConstants.DEFAULT_TECHPAD_CONTROL_DATE_EMPTY_DATE &&
             self.contact.ContactDate !== commonConstants.DEFAULT_FOX_PRO_EMPTY_DATE){
              contactDate = new Date(self.contact.ContactDate);
          }

          const todayStringFormat = `${contactDate.getMonth()+1}/${contactDate.getDate()}/${contactDate.getFullYear()}`;
          self.contact.ContactDate = todayStringFormat;

          self.contactCopy = angular.copy(self.contact);
        }

        self.loadContact = async () => {
          try {
            const response = await documentsSvc.loadContact(self.ssn, self.contactId);
            self.contact = response.data;
          } catch (errorResponse) {
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_LOAD_CONTACT_TYPES_ERROR_MESSAGE);
            self._scope.model.isCanceled = true;
            self.modalInstance.remove();
          }
        };

        self.loadFollowUpsOnDue = async () => {
          self.areFollowUpsLoaded = false;
          try {
            const resp = await FollowUpsDomain.loadFollowUpsOnDue(self.ssn);
            self.followUpsOnDue = resp || [];
            self.areFollowUpsLoaded = true;
          } catch (errorResponse) {
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_LOAD_FU_ERROR_MESSAGE);
          }

          if(self.areFollowUpsLoaded && self.followUpsOnDue.length){
            try {
              const resp = await FollowUpsDomain.getRecommendations();
              self.recommendations = resp || [];

              self.prepareFollowUpProperties();
            } catch (errorResp) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResp || commonConstants.DEFAULT_LOAD_FU_RECOMMENDATIONS_ERROR_MESSAGE);
            }

            try {
              const resp = await FollowUpsDomain.getResolutions();
              self.resolutions = resp || [];
            } catch (errorResp) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResp || commonConstants.DEFAULT_LOAD_FU_RESOLUTIONS_ERROR_MESSAGE);
            }

          }
        }

        self.prepareFollowUpProperties = () => {
          self.followUpsOnDue.map(item => {
            item.RecommendationDescription = self.getRecommendationDescription(item.Recommendation);
            item.Letters = self.getLettersDescription(item.RecLet);
          });
        }

        self.getLettersDescription = (recLet) => {
          let response = '';
          switch (recLet){
            case commonConstants.DEFAULT_FU_LETTERS_NONE_CODE:
              response = commonConstants.DEFAULT_FU_LETTERS_NONE_DESCRIPTION;
              break;
            case commonConstants.DEFAULT_FU_LETTERS_FIRST_CODE:
              response = commonConstants.DEFAULT_FU_LETTERS_FIRST_DESCRIPTION;
              break;
            case commonConstants.DEFAULT_FU_LETTERS_SECOND_CODE:
              response = commonConstants.DEFAULT_FU_LETTERS_SECOND_DESCRIPTION;
              break;
            case commonConstants.DEFAULT_FU_LETTERS_THIRD_CODE:
              response = commonConstants.DEFAULT_FU_LETTERS_THIRD_DESCRIPTION;
              break;
          }
          return response;
        }

        self.getRecommendationDescription = (recommendationCode) => {
          const formattedCode = recommendationCode && recommendationCode.trim();
          const recommendation = self.recommendations.find(item => item.Code === formattedCode);
          const recommendationDescription = recommendation && recommendation.Description || formattedCode;

          return recommendationDescription;
        }

        self.loadContactTypes = async () => {
          try {
            const resp = await documentsSvc.loadContactTypes();
            self.contactTypes = resp.data;
          } catch (errorResponse) {
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_LOAD_CONTACT_TYPES_ERROR_MESSAGE);
            self._scope.model.isCanceled = true;
            self.modalInstance.remove();
          }
        }

        self.changeDate = (obj, id) => {
          const changeDateModel = {
            obj: obj,
            id: id
          };
          datePickerService.changeDate(changeDateModel);
        };

        self.areValidContactRequiredFields = () => {
          self.highlightInvalidData = true;
          let isValid = !!self.contact.Code;
          return isValid;
        }

        self.saveContact = async (isCloseModal) => {
          let canProceed = self.areValidContactRequiredFields();
          if (!canProceed) {
            await modalService.showAlertAsync(commonConstants.DEFAULT_CONTACT_TYPE_REQUIRED_MESSAGE);
          }

          if (canProceed && !signalrService.isConnected) {
            await modalService.showAlertAsync(commonConstants.OFFLINE_ERROR_MESSAGE);
            canProceed = false;
          }

          if(canProceed){
            $ionicLoading.show({template: commonConstants.processingLoaderMessage});
            const stilOwning = await self.checkIfStillOwningAndNotOffline();
            $ionicLoading.hide();
            if(!stilOwning){
              canProceed = false;
              self.close();
            }
          }

          if(canProceed){
            try {
              $ionicLoading.show({
                template: commonConstants.DEFAULT_SAVE_CONTACT_LOADING_MESSAGE
              });

              if(self.contact.Id){
                await documentsSvc.updateContact(self.contact);
              }else{
                self.contact.Ssn = self.ssn;
                const createContactResponse = await documentsSvc.createContact(self.contact);
                self.contactId = createContactResponse.data;
                self._scope.model.isCreated = true;
              }

              $ionicLoading.hide();

              if(isCloseModal){
                self._scope.model.isCanceled = false;
                self.modalInstance.remove();
              }else{
                await self.loadContact();
                self.processDataOnInit();
                await modalService.showAlertAsync(commonConstants.DEFAULT_CONTACT_SAVED_MESSAGE);
              }
            } catch (errorResponse) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_SAVE_CONTACT_ERROR_MESSAGE);
            }
          }
        }

        self.close = async (showConfirmationModal) => {
          const isChanged = !angular.equals(self.contact, self.contactCopy);
          let isStay = false;
          if (showConfirmationModal && isChanged) {
            const isConfirmed = await modalService.showConfirmationAsync(commonConstants.DEFAULT_CHANGES_DETECTED_ON_POPUP_CLOSE_CONFIRMATION_MESSAGE);
            if(!isConfirmed){
              isStay = true;
            }
          }

          if(!isStay){
            self._scope.model.isCanceled = true;
            self.modalInstance.remove();
          }
        };

        self.onDeletedFollowUp = async () => {
          await self.loadFollowUpsOnDue();
          if(!!self.followUpOnDueToResolve){
            self.cancelResolveFollowUp();
          }
        }

        self.deleteFollowUp = async (followUp) => {
          const formattedRecallDate = self.formatDateString(followUp.RecallDate);
          const isConfirmed = await modalService.showConfirmationAsync(
            `Are you sure you want to delete this follow-up due on date ${formattedRecallDate}?`
          );
          if(isConfirmed){
            try {
              $ionicLoading.show({
                template: commonConstants.DEFAULT_DELETE_FU_LOADING_MESSAGE
              });

              let canProceed = true;
              if (!signalrService.isConnected) {
                $ionicLoading.hide();
                await modalService.showAlertAsync(commonConstants.OFFLINE_ERROR_MESSAGE);
                canProceed = false;
              }

              if(canProceed){
                $ionicLoading.show({template: commonConstants.processingLoaderMessage});
                const stilOwning = await self.checkIfStillOwningAndNotOffline();
                $ionicLoading.hide();
                if(!stilOwning){
                  canProceed = false;
                  self.close();
                }
              }

              if(canProceed){
                await FollowUpsDomain.deleteFollowUp(followUp.Id);
                $ionicLoading.hide();
                await self.onDeletedFollowUp();
              }
            } catch (errorResponse) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_REMOVE_FU_ERROR_MESSAGE);
            }
          }
        };

        self.resolveFollowUp = async (followUp) => {
          self.followUpOnDueToResolve = angular.copy(followUp);
        };

        self.proceedResolveFollowUp = async () => {
          self.cancelResolveFollowUp();
          await self.loadFollowUpsOnDue();
          self._scope.model.isFuResolved = true;
        }

        self.cancelResolveFollowUp = () => {
          const isLostOwnership = self.followUpOnDueToResolve && self.followUpOnDueToResolve.isLostOwnership;
          self.followUpOnDueToResolve = undefined;
          if(isLostOwnership){
            self.close();
          }
        }

        self.formatDateString = (dateString) => {
          const date = new Date(dateString);
          const formattedDate = `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
          return formattedDate;
        }
      }

      return ContactDocumentCreateDialogModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/ContactDocumentCreateDialogModel.js